<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4 4L20 20"
      stroke="#606367"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.75921 4.67342C4.66139 5.97782 4 7.66167 4 9.5V11V17C4 17.5523 4.44772 18 5 18H7C8.65685 18 10 16.6569 10 15V13C10 11.3431 8.65685 10 7 10H6V9.5C6 8.21416 6.44125 7.03137 7.1806 6.09481L5.75921 4.67342ZM14.8362 10.922C15.3821 10.3537 16.1498 10 17 10H18V9.5C18 6.46243 15.5376 4 12.5 4H11.5C10.4721 4 9.51006 4.28198 8.68701 4.7728L7.24039 3.32618C8.45025 2.48986 9.91792 2 11.5 2H12.5C16.6421 2 20 5.35786 20 9.5V11V16.0858L18 14.0858V12H17C16.702 12 16.4345 12.1303 16.2513 12.3371L14.8362 10.922ZM14.0012 12.9154C14.0004 12.9435 14 12.9717 14 13V15C14 16.6569 15.3431 18 17 18H17.6126L17.5072 18.3162C17.3711 18.7246 16.9889 19 16.5585 19H13C12.4477 19 12 19.4477 12 20C12 20.5523 12.4477 21 13 21H16.5585C17.8498 21 18.9962 20.1737 19.4045 18.9487L19.562 18.4762L17.0858 16H17C16.4477 16 16 15.5523 16 15V14.9142L14.0012 12.9154ZM6 16V12H7C7.55228 12 8 12.4477 8 13V15C8 15.5523 7.55228 16 7 16H6Z"
      fill="#606367"
    />
  </svg>
</template>
